import { Component, ViewChild } from '@angular/core';

import { Platform,Events, MenuController, Nav, NavController, NavParams, } from 'ionic-angular';
import { Network } from '@ionic-native/network';


import { StartUpPage } from '../pages/startup/startup';
import { LoginPage } from '../pages/login/login';
import { HomePage } from '../pages/home/home';
import { CalendarPage } from '../pages/calendar/calendar';
import { DirectionsPage } from '../pages/directions/directions';
import { VideoPage } from '../pages/video/video';
import { ForgotPage } from '../pages/forgot/forgot';
import { ResetpwdPage } from '../pages/resetpwd/resetpwd';
import { VisitorsPreRegPage } from '../pages/visitors-prereg/visitors-prereg';
import { VisitorsRegDisclaimerPage } from '../pages/visitors-reg-disclaimer/visitors-reg-disclaimer';
import { VisitorsRegMorePage } from '../pages/visitors-reg-more/visitors-reg-more';
import { SecurityhomePage } from '../pages/securityhome/securityhome';
import { CheckinPage } from '../pages/checkin/checkin';
import { ReactivatePage } from '../pages/reactivate/reactivate';
import { ReactivateotpPage } from '../pages/reactivateotp/reactivateotp';
import { VisitoreditPage } from '../pages/visitoredit/visitoredit';
import { VisitorreportPage } from '../pages/visitorreport/visitorreport';
 

import { VisitorsRegPage } from '../pages/visitors-reg/visitors-reg';

import { Storage } from '@ionic/storage';
import { StatusBar } from '@ionic-native/status-bar';
import { SplashScreen } from '@ionic-native/splash-screen';


@Component({
  templateUrl: 'app.html'
})
export class MyApp {
  @ViewChild(Nav) nav: Nav;

  rootPage = StartUpPage;
  pages: Array<{title: string, component: any}>;

  constructor(
    public platform: Platform,
    public menu: MenuController,
    public statusBar: StatusBar,
    public splashScreen: SplashScreen,
    public storage: Storage, 
    public events: Events,
    private network: Network
  ) {
    this.initializeApp();

    // set our app's pages
    this.pages = [
      { title: 'Start up', component: StartUpPage },
      { title: 'Login', component: LoginPage },
      { title: 'Home', component: HomePage },
      { title: 'Visitors Registration', component: VisitorsRegPage },
      //{ title: 'Visitors Registration-2', component: VisitorsRegMorePage },
      { title: 'Disclaimer', component: VisitorsRegDisclaimerPage },
      { title: 'Visitor Pre-Registration', component: VisitorsPreRegPage },
      { title: 'Check-In', component: CheckinPage },
      { title: 'Security home', component: SecurityhomePage },
      //{ title: 'Security home', component: VisitoreditPage },
      { title: 'Reactivate', component: ReactivatePage },
    ];
  }
  

  

  initializeApp() {
    this.platform.ready().then(() => {
      this.statusBar.styleDefault();
      this.splashScreen.hide();
      this.menu.enable(false);
      this.listenConnection();

      /*

      this.events.subscribe('network:offline', () => {
          alert('network:offline ==> '+this.network.type);    
      });

      // Online event
      this.events.subscribe('network:online', () => {
          alert('network:online ==> '+this.network.type);        
      });

      */
      this.storage.get('accesscode').then((val) => {
          
        if(val == null){
          this.nav.push(LoginPage);
          //this.nav.push(ResetpwdPage);
          
        }else{
          this.storage.get('userrole').then((val) => {
            if(val == 'ROLE_SECURITY' || val == 'ROLE_RECEPTION'){
              this.nav.push(SecurityhomePage);
            }else if(val == 'ROLE_VISITOR'){
              this.nav.push(HomePage);
            }
          });
          
        }
      });
    });
  }

  private listenConnection(): void {
    this.network.onDisconnect()
      .subscribe(() => {
        this.showAlert();
      });

    this.network.onConnect()
      .subscribe(() => {
        this.showAlert();
      });
  }

  private showAlert(): void {
    // omitted;
  }
/*
  ionViewDidEnter() {
    this.network.onConnect().subscribe(data => {
      console.log(data)
    }, error => console.error(error));
   
    this.network.onDisconnect().subscribe(data => {
      console.log(data)
    }, error => console.error(error));
  }
  */
  openPage(page:any){
    console.log('sdf = '+page.component.name);
    if(page.component.name == 'StartUpPage'){
      this.nav.push(StartUpPage);
    }else if(page.component.name == 'LoginPage'){
      this.nav.push(LoginPage);
    }else if(page.component.name == 'HomePage'){
      this.nav.push(HomePage);
    }else if(page.component.name == 'VisitorsRegPage'){
      this.nav.push(VisitorsRegPage);
    }else if(page.component.name == 'VisitorsRegMorePage'){
      this.nav.push(VisitorsRegMorePage);
    }else if(page.component.name == 'VisitorsRegDisclaimerPage'){
      this.nav.push(VisitorsRegDisclaimerPage);
    }else if(page.component.name == 'VisitorsPreRegPage'){
      this.nav.push(VisitorsPreRegPage);
    }else if(page.component.name == 'SecurityhomePage'){
      this.nav.push(SecurityhomePage);
    }else if(page.component.name == 'CheckinPage'){
      this.nav.push(CheckinPage);
    }else if(page.component.name == 'ReactivatePage'){
      this.nav.push(ReactivatePage);
    }/*else if(page.component.name == 'ReactivateotpPage'){
      this.nav.push(ReactivateotpPage);
    }*/
    
  }
}



// WEBPACK FOOTER //
// ./src/app/app.component.ts